import React from 'react';

function Notebook() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="35.071"
			height="50"
			viewBox="0 0 35.071 50"
		>
			<g
				fill="none"
				stroke="#2d2d2d"
				strokeLinejoin="round"
				strokeWidth="3"
				transform="translate(0 1.5)"
			>
				<path
					d="M3.357 5.036V1.679A1.679 1.679 0 015.036 0h26.857a1.679 1.679 0 011.679 1.679V35.25a1.679 1.679 0 01-1.679 1.679H5.036a1.679 1.679 0 01-1.679-1.679v-3.357"
					data-name="Path 12"
				></path>
				<path
					d="M0 0L7 0"
					data-name="Line 32"
					transform="translate(0 8)"
				></path>
				<path
					d="M0 0L7 0"
					data-name="Line 33"
					transform="translate(0 15)"
				></path>
				<path
					d="M0 0L7 0"
					data-name="Line 34"
					transform="translate(0 22)"
				></path>
				<path
					d="M0 0L7 0"
					data-name="Line 35"
					transform="translate(0 29)"
				></path>
				<path
					d="M0 0L11 0"
					data-name="Line 36"
					transform="translate(13 13)"
				></path>
				<path
					d="M0 0L11 0"
					data-name="Line 37"
					transform="translate(13 18)"
				></path>
			</g>
		</svg>
	);
}

export default Notebook;
